// extracted by mini-css-extract-plugin
module.exports = {"cell":"US-h3","selected":"y-fs1"};